import { render } from "./RegisterButton.vue?vue&type=template&id=0fb4a45d"
import script from "./RegisterButton.vue?vue&type=script&lang=js"
export * from "./RegisterButton.vue?vue&type=script&lang=js"

import "./RegisterButton.vue?vue&type=style&index=0&id=0fb4a45d&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__